import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 p-4 relative min-h-300" }
const _hoisted_2 = { class: "flex gap-4 h-full flex-grow" }
const _hoisted_3 = { class: "flex flex-col gap-5 w-2/3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl" }, " Document information ", -1)
const _hoisted_5 = { class: "flex gap-4" }
const _hoisted_6 = { class: "flex flex-col gap-2 w-1/2 overflow-hidden" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg" }, " Information ", -1)
const _hoisted_8 = { class: "flex gap-4 text-sm" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Sender", -1)
const _hoisted_10 = { class: "flex gap-4 text-sm" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Access", -1)
const _hoisted_12 = { class: "flex gap-2" }
const _hoisted_13 = { class: "flex gap-4 text-sm" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Received", -1)
const _hoisted_15 = { class: "flex gap-4 text-sm" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Scanned", -1)
const _hoisted_17 = { class: "flex gap-4 text-sm" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Last updated", -1)
const _hoisted_19 = { class: "flex flex-col w-1/2 gap-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg" }, " Statistics ", -1)
const _hoisted_21 = { class: "flex gap-4 text-sm" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, " Pages ", -1)
const _hoisted_23 = { class: "border-0 border-l border-solid flex flex-col gap-5 w-1/3 flex-shrink-0 border-gray-300 -my-4 pl-4 py-4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl" }, "Activity", -1)
const _hoisted_25 = { class: "flex flex-col gap-2" }

import { Dialog, UiButton, UiAvatar } from '@/ui-kit';
import { useToggle } from '@vueuse/core';
import { Mail } from '../mail';
import { Mailbox } from '../mailbox';
import { format, addMonths } from 'date-fns';


export default /*#__PURE__*/_defineComponent({
  __name: 'VirtualMailAuditTrailDialog',
  props: {
    selectedMail: null,
    mailbox: null
  },
  setup(__props: any, { expose }) {

const [isOpened, setIsOpened] = useToggle();



expose({
	openDialog: () => setIsOpened(true)
});

function toDate(dateString?: string): string {
	if (!dateString) {
		return '';
	}

	try {
		dateString = dateString.includes('Z')
			? dateString
			: dateString + 'Z';

		return format(new Date(dateString), 'MMM d, yyyy');
	} catch (e) {
		return '';
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    modelValue: _unref(isOpened),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(setIsOpened)(false)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("span", null, _toDisplayString(__props.selectedMail
											.json_file
											.SENDER_COMPANY) + " " + _toDisplayString(__props.selectedMail
											.json_file
											.SENDER_NAME), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.mailbox.team_members, (item) => {
                      return (_openBlock(), _createBlock(_unref(UiAvatar), {
                        class: "h-5 w-5 text-xs bg-blue-200 bg-opacity-50",
                        key: item.id,
                        avatar: 
											item.avatar
												?.path
										,
                        name: item.name
                      }, null, 8, ["avatar", "name"]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("span", null, _toDisplayString(toDate(
											__props.selectedMail
												?.json_file
												.RECEIVED_DATE
										)), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("span", null, _toDisplayString(toDate(
											__props.selectedMail
												?.json_file
												.SCAN_DATE
										)), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("span", null, _toDisplayString(toDate(
										__props.selectedMail.updated_at
									)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("span", null, _toDisplayString(__props.selectedMail.pages
											.length), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.selectedMail.log, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "text-sm",
                  key: i
                }, _toDisplayString(item.causer?.name ||
								'Thatch') + " " + _toDisplayString(item.action) + " mail " + _toDisplayString(toDate(item.created_at)), 1))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})